import { useEffect, useState } from "react";

import { useLanguage } from "@/i18n/LanguageContext";

function parts(target: Date) {
  const diff = Math.max(0, target.getTime() - Date.now());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { days, hours, minutes, seconds };
}

export function Countdown({ startAt }: { startAt: string }) {
  const { t } = useLanguage();
  const target = new Date(startAt);
  const [value, setValue] = useState(() => parts(target));

  useEffect(() => {
    const id = window.setInterval(() => setValue(parts(target)), 1000);
    return () => window.clearInterval(id);
  }, [startAt]);

  const items = [
    [value.days, t.hero.days],
    [value.hours, t.hero.hours],
    [value.minutes, t.hero.minutes],
    [value.seconds, t.hero.seconds],
  ] as const;

  return (
    <div>
      <div className="dn-muted" style={{ marginBottom: "0.5rem", color: "rgba(255,255,255,0.85)" }}>
        {t.hero.countdown}
      </div>
      <div className="dn-countdown">
        {items.map(([n, label]) => (
          <div key={label}>
            <strong>{String(n).padStart(2, "0")}</strong>
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
